module.exports = __webpack_public_path__ + "static/media/building-view.863e9dce.svg";